import { render, staticRenderFns } from "./journey_detail.vue?vue&type=template&id=69f88bef&scoped=true&"
import script from "./journey_detail.vue?vue&type=script&lang=js&"
export * from "./journey_detail.vue?vue&type=script&lang=js&"
import style0 from "./journey_detail.vue?vue&type=style&index=0&id=69f88bef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f88bef",
  null
  
)

export default component.exports